import { privateApi } from '../ApiService/PrivateApi';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import { MessagingChannel, CreateMessagingChannelRequest } from './types';

const fetchChannels = async (businessAccountId: string): Promise<MessagingChannel[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<MessagingChannel[]>(
        `business-accounts/${businessAccountId}/messaging/channels`,
    );

const createChannel = async (request: CreateMessagingChannelRequest): Promise<MessagingChannel> =>
    privateApi.post<MessagingChannel>('messaging/channels', request);

const enableChannel = async (channelId: string): Promise<MessagingChannel> =>
    privateApi.post<MessagingChannel>(`messaging/channels/${channelId}/enable`);

const disableChannel = async (channelId: string): Promise<MessagingChannel> =>
    privateApi.post<MessagingChannel>(`messaging/channels/${channelId}/disable`);

export const MessagingChannelsGateway = {
    fetchChannels,
    createChannel,
    enableChannel,
    disableChannel,
};
